import useLoadingIndicator from "../../component/Loader/Loader";
import MainCard from "../../component/MainCard/MainCard";
import { Strings } from "../../constant/Strings";
import { useMemo, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TiArrowUnsorted } from "react-icons/ti";
import ShowEntries from "../../component/ShowEntries/ShowEntries";
import TablePagination from "../../component/TablePagination/TablePagination";
import {
  useTable,
  useGlobalFilter,
  usePagination,
  useSortBy,
} from "react-table";
import { icons } from "../../assets";
import { showErrorToastMessage } from "../../component/Toasts/Toasts";
import * as actions from "../../Redux/Actions";
import ModalComponents from "../../component/ModalComponent/ModalComponent";
import UpdateQuestion from "./updateQuestion";

const ChatBotModule = () => {
  const {
    loadingComponent,
    showLoadingIndicator,
    hideLoadingIndicator,
    apiCallCompleted,
  } = useLoadingIndicator();
  const { chatManagementLabel } = Strings;
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState<Number>(1);
  const [totalEntries, setTotalEntries] = useState<any>();
  const [pageSize, setPageSize] = useState<any>(10);
  const dispatch = useDispatch();
  const [showAssignRoles, setShowAssignRoles] = useState(false);
  const [ChatBotDetails, setChatBotDetails] = useState({});
  const editEmployeeRoles = useSelector(
    (state: any) => state.employeeReducer.postUpdateRoles
  );

 
  useEffect(() => {
    GetApiDispatch();
  }, [
    editEmployeeRoles,
    totalEntries,
    pageSize,
    page,
  ]);

  const GetApiDispatch = () => {
    showLoadingIndicator();
   
    dispatch(
      actions.chatBotGetAllQuestionAction((res: any) => {
            if (res?.error?.error_description) {
              showErrorToastMessage(res.error.error_description);
              hideLoadingIndicator();
            } else if (res.code === 200) {
              setData(res.data);
              setTotalEntries(res.data.length);
              const result = Number(res.data.count) / Number(pageSize);
              const pageNo = result % 1 === 0 ? result : Math.ceil(result);
              setTotalPages(pageNo);
              hideLoadingIndicator();
            }
      })
    );
  };

  const handleEdit = (data: any) => {
    setChatBotDetails(data);
    setShowAssignRoles(true);
  };

  const columns: any = useMemo(
    () => [
      {
        Header: "SL NO.",
        accessor: "index",
        Cell: ({ row }: any) => <div>{row.index + 1}</div>,
      },
      {
        Header: "Question",
        accessor: "question",
        Cell: ({ value }: any) => <div>{value}</div>,
      },
      {
        Header: "Answers",
        accessor: "answer",
        Cell: ({ value }: any) =><div>{value}</div>,
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value }: any) => <div className={
            value === "New"
              ? "new-text-status"
              : value === "Approved"
              ? "accepted-text-status"
              : value === "Rejected"
              ? "declined-text-status"
              : ""
          }>
            {value}
        </div>,
      },
      {
        Header: "Action",
        accessor: "action",
        Cell: (Action: any) => {
          return (
            <>
              <div className="d-flex flex-start justify-content-center align-items-start h-100 action-btn">
                <img
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Edit"
                  src={icons.edit_blue_icon}
                  alt="edit_icon"
                  className="edit-icon mx-2 my-2"
                  onClick={() => handleEdit(Action.row.original)}
                />
               
              </div>
            </>
          );
        },
      },
    ],
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data,
        initialState: {
          pageSize: pageSize,
          pageIndex: 0,
        },
      },
      useGlobalFilter,
      useSortBy,
      usePagination
    );

  const handlePageChange = (newPage: any) => {
    setPage(newPage);
  };



  const hideAssignRoles = () => {
    setShowAssignRoles(false);
  };


  return (
    <>
      {loadingComponent()}
      <MainCard>
        <div className="heading-button-wrapper">
          <div>
            <h2>{chatManagementLabel}</h2>
          </div>
        </div>
        <div className="mt-2">
          {data?.length > 0 ? (
            <>
              <div className="table table-responsive">
                <table
                  className="table-main table table-sm mt-3"
                  {...getTableProps()}
                >
                  <thead className="table-head">
                    {headerGroups.map((headerGroup) => (
                      <tr
                        className="table-head-row"
                        {...headerGroup.getHeaderGroupProps()}
                      >
                        {headerGroup.headers.map((column: any) => (
                          <th
                            className="table-head-row"
                            {...column.getHeaderProps()}
                            scope="col"
                          >
                            {column.render("Header")}

                            <span>
                              {column.id !== "Action" && column.id !== "id" ? (
                                column.isSorted ? (
                                  column.isSortedDesc ? (
                                    <TiArrowUnsorted />
                                  ) : (
                                    <TiArrowUnsorted />
                                  )
                                ) : (
                                  <TiArrowUnsorted />
                                )
                              ) : (
                                ""
                              )}
                            </span>
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>
                  <tbody className="table-body" {...getTableBodyProps()}>
                    {rows.map((row, index) => {
                      prepareRow(row);
                      return (
                        <tr className="table-body-row" {...row.getRowProps()}>
                          {row.cells.map((cell: any) => {
                            return (
                              <td
                                {...cell.getCellProps()}
                                style={
                                  cell?.column?.id === "answer"
                                    ? { width: "50%" }
                                    : {}
                                }
                              >
                                {cell.render("Cell")}
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              <div className="show-entries-wrapper">
                <ShowEntries
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  totalRecords={0}
                  totalEntries={totalEntries}
                />

                <TablePagination
                  totalPages={totalPages}
                  currentPage={page}
                  onClick={handlePageChange}
                />
              </div>
            </>
          ) : (
            <p className="employeedata">No Data Found</p>
          )}
        </div>
        <ModalComponents
          show={showAssignRoles}
          onHide={hideAssignRoles}
          title={"Update question"}
          modalBody={
          <UpdateQuestion
                  chatBotDetails={ChatBotDetails}
                  hideAssignRoles={hideAssignRoles}
                  apiCallCompleted={apiCallCompleted} 
                  GetApiDispatch={GetApiDispatch}
                  />
          }
          className="modal-lg"
        />
       
      </MainCard>
    </>
  );
};

export default ChatBotModule;
